import httpBuildQuery from "locutus/php/url/http_build_query";

export const getDownloadUrl = params => `/download/?${httpBuildQuery(params)}`;

export const getImageUrl = params => {
  if (params.versionId) {
    params.ttl = 644400;
  }
  if (!params.fileType) {
    params.fileType = "auto";
  }
  return getDownloadUrl(params);
};
